import { fPageByResourceId, FPageFlag, FSection } from '../mdl/f-page';
import { FPageBlock } from '../mdl/f-page-block';
import { getCountry } from '../me/me';
import { uiRegisterAnchor } from '../ui/anchor';
import { uiSetBG } from '../ui/bg';
import { $el } from '../ui/elements';
import { UIScreen } from '../ui/screen';
import { UIViewAddSpec } from '../ui/view';
import { $cdn } from '../y/cdn';
import { $log } from '../y/debug';
import { YFlags } from '../y/types';
import { block_registry } from './registry';

export function makePageBlock(b: FPageBlock, section: HTMLElement, promises: Promise<any>[], id: string, page_flags: YFlags<FPageFlag>): UIViewAddSpec | undefined {
    const maker = block_registry[b.type] as (b: FPageBlock, section: HTMLElement, promises: Promise<any>[], id: string, page_flags: YFlags<FPageFlag>) => UIViewAddSpec | undefined;
    if(maker)
        return maker(b, section, promises, id, page_flags);
    $log('app', '%cUnknown block type: ' + b.type, $log.RED)
    return;
}

export function blkMakeSection(s: FSection, n: number, screen: UIScreen, promises: Promise<any>[], page_flags: YFlags<FPageFlag>, menu_maker?: () => UIViewAddSpec): HTMLElement | undefined {
    const properties = s.properties;
    const section = $el.SECTION([properties.bg_sticky && 'm-sticky-bg']);
    section.ui_add(s.blocks.map((b, bn) => makePageBlock(b, section, promises, `${n}-${bn}`, page_flags)));

    uiSetBG(section, properties.bg);

    if(n == 0) {
        if(properties.bg.color)
            screen.titlebar_color = properties.bg.color;
        else if(properties.bg.gradient)
            screen.titlebar_color = properties.bg.stops[0][0];
    }

    if(n == 0 && menu_maker) {
        section.classList.add('pad-t-none', 'm-with-menu');
        if(properties.header) {
            section.ui_prepend($el.S());
            section.ui_add($el.S());
        }
        section.ui_prepend([menu_maker(), properties.padding_top != 'none' && $el.DIV(properties.padding_top == 'wide' ? 's-spread' : 's-medium')]);
    } else {
        if(properties.padding_top) {
            section.classList.add('pad-t-' + properties.padding_top);
            if(properties.padding_top == 'overlap')
                section.ui_prepend($el.DIV('ui-section-overlap-top'));
        }
    }

    if(properties.padding_bottom) {
        section.classList.add('pad-b-' + properties.padding_bottom);
        if(properties.padding_bottom == 'overlap')
            section.ui_add($el.DIV('ui-section-overlap-bottom'));
    }

    if(properties.deco?.kind) {
        section.classList.add('m-decorated-' + properties.deco.kind);
        for(let i = 0; i < properties.deco.images.length; ++i) {
            const v = properties.deco.images[i];
            if(v.image) {
                const deco = $el.DIV(['r-deco r-deco-' + (i + 1)]);
                deco.style.setProperty('--ui-image', `url('${$cdn.media(v.image)}')`);
                deco.style.setProperty('--ui-width', v.width + 'px');
                deco.style.setProperty('--ui-aspect', v.aspect + '');
                section.ui_add(deco);
            }
        }
    }

    if(properties.deco?.kind == 'hero' || properties.padding_top == 'overlap' || properties.padding_bottom == 'overlap')
        section.classList.add('m-overflow');

    if(properties.header)
        section.classList.add('m-700');

    if(properties.color_scheme != 'inherit')
        section.classList.add('c-' + properties.color_scheme);

    if(s.name)
        uiRegisterAnchor(section, s.name);

    return section;
}

export async function blkRenderResource(resource_id: string, screen: UIScreen): Promise<UIViewAddSpec> {
    const page = await fPageByResourceId(resource_id);
    if(!page) return [];
    const promises: Promise<any>[] = [];
    const sections = page.sections.filter(s => !(Object.keys(s.countries).length && !s.countries[getCountry()]))
    const content = sections.map((s, n) => blkMakeSection(s, n, screen, promises, page.flags));
    if(promises)
        await Promise.all(promises);
    return content;
}